import { render, staticRenderFns } from "./JobDetails.vue?vue&type=template&id=bd4dda42&scoped=true&"
import script from "./JobDetails.vue?vue&type=script&lang=js&"
export * from "./JobDetails.vue?vue&type=script&lang=js&"
import style0 from "./JobDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./JobDetails.vue?vue&type=style&index=1&id=bd4dda42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4dda42",
  null
  
)

export default component.exports